import { Icon } from '@plone/volto/components';
import React, { FC, useEffect } from 'react';
import CompactFilterDialog from './CompactFilterDialog';
import CompactFilterObject, { CompactFilterValue } from './CompactFilterObject';

const CompactFilter: FC<{
  filter: CompactFilterObject[];
  updateFilter: (filterObject: CompactFilterObject) => void;
  openDialog: number;
  setOpenDialog: React.Dispatch<React.SetStateAction<number>>;
}> = ({ filter, updateFilter, openDialog, setOpenDialog }) => {
  const updateFilterItem = (
    filter: CompactFilterObject,
    newFilter: CompactFilterValue,
  ): string[] => {
    if (filter.active.includes(newFilter.value)) {
      filter.active.splice(filter.active.indexOf(newFilter.value), 1);
    } else {
      return [...filter.active, newFilter.value];
    }

    return filter.active;
  };

  // close filter dialog if user clicks outside of dialog
  // @ts-ignore
  function handleFilterClick(event) {
    if (
      !(
        event.target.classList.contains('filter') ||
        event.target.parentElement.classList.contains('filter') ||
        event.target.classList.contains('filterdialog') ||
        event.target.classList.contains('filteritem') ||
        event.target.parentElement.classList.contains('filteritem')
      )
    ) {
      setOpenDialog(-1);
    }
  }

  useEffect(() => {
    // add click event listener to the document object
    document.addEventListener('click', handleFilterClick);

    // remove event listener on unmount
    return () => {
      document.removeEventListener('click', handleFilterClick);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={'filtercontainer'}>
      {filter.map((filterItem, idx) => (
        <div className={`filter-wrapper`} key={idx}>
          <button
            aria-label={filterItem.title}
            title={filterItem.title}
            data-active={!!(openDialog === idx || filterItem.active?.length)}
            className={`filter`}
            onClick={() => {
              if (filterItem.type === 'switch') {
                updateFilter({
                  ...filterItem,
                  active: updateFilterItem(filterItem, filterItem.all[0]),
                });
              } else {
                setOpenDialog((prevState) => {
                  if (prevState === idx) return -1;
                  else return idx;
                });
              }
            }}
          >
            <Icon className={'icon'} name={filterItem.icon} size={'1.25rem'} />
            <span>{filterItem.title}</span>
            {filterItem.active?.length && filterItem.type !== 'switch' ? (
              <span className={'amount'}>({filterItem.active.length})</span>
            ) : (
              <></>
            )}
          </button>
          {openDialog === idx ? (
            <CompactFilterDialog
              values={filterItem.all}
              active={filterItem.active}
              onChangeValue={(filter) => {
                updateFilter({
                  ...filterItem,
                  active: updateFilterItem(filterItem, filter),
                });
              }}
            />
          ) : (
            <></>
          )}
        </div>
      ))}
    </div>
  );
};

export default CompactFilter;
